import { component as defineComponent } from 'flightjs';
import URI from 'urijs';

var UserRegistration = function() {
    this.attributes({
        endpoint: '/accounts/xhr/signup',
    });

    this.after('initialize', function() {
        this.on(document, 'uiUserRegistrationRequested', this.sendRegistrationRequest);
        this.on('dataUserRegistrationSuccess', this.trackSignup);
    });

    this.trackSignup = function(e, data) {
        if (window.analytics) {
            window.analytics.alias(data.userid);
            window.analytics.identify(data.userid);
            window.analytics.track('Launch Signup');
        }
    };

    this.sendRegistrationRequest = function(e, data) {
        var xhr = $.ajax({
            url: this.attr.endpoint,
            method: 'post',
            data: JSON.stringify(data),
            contentType: 'application/json',
        });

        xhr.done(
            function(res) {
                $.ajax(this.postLoginURL(res)).done(
                    function() {
                        this.trigger('dataUserRegistrationSuccess', res);
                    }.bind(this)
                );
            }.bind(this)
        );

        xhr.error(
            function(res) {
                this.trigger('dataUserRegistrationFailure', res.responseJSON);
            }.bind(this)
        );
    };

    this.postLoginURL = function(res) {
        var payload = new URI(res.target).segment(-1);

        return '/postlogin/xhr/' + payload;
    };
};

export default defineComponent(UserRegistration);



// WEBPACK FOOTER //
// ./src/web/js/launch/data/user-registration.js